export default function formatPercentage(number: number, locale: string[] = ['cs']): string {
	return Intl.NumberFormat(locale, {
		style: 'percent',
		minimumFractionDigits: 2,
		maximumFractionDigits: 3,
	})
		.format(number / 100)
		.replace(/ /g, '\xA0');
}
